<div class="dialog-wrapper">
	<h1 mat-dialog-title>Selecteer profielfoto</h1>
	<div mat-dialog-content class="cropper-content">
		<img id="image" [src]="sanitizedUrl">
	</div>
	<div align="end" mat-dialog-actions>
		<button type="button" class="btn" (click)="reset()">
			Reset
		</button>

		<button type="button" class="btn primary" cdkFocusInitial (click)="crop()">
			<span class="button-text">Opslaan</span>

			<span class="button-icon">
				<fa-icon matSuffix [icon]="['fas', 'arrow-right-long']"></fa-icon>
			</span>
		</button>
	</div>

	<button mat-icon-button class="close-dialog" mat-dialog-close>
		<fa-icon class="close-icon" matSuffix [icon]="['fas', 'times']"></fa-icon>
	</button>
</div>